import React, { ChangeEvent, FC, memo, useEffect, useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { CustomKeyboardEvent } from 'src/types';

interface Props {
  searchLabel?: string;
  value?: string;
  isClearEvent?: boolean;
  isDisable?: boolean;
  onHandleSearchKeyword: (searchKeyword: string) => void;
  onEnterPress?: (event: CustomKeyboardEvent) => void;
}

const component: FC<Props> = ({
  // eslint-disable-next-line no-unused-vars
  value,
  searchLabel = 'Search Products',
  isClearEvent,
  isDisable = false,
  onHandleSearchKeyword,
  onEnterPress = () => {}
}) => {
  const [searchInput, setSearchInput] = useState<string>('');

  const onChangeKeyword = (event: ChangeEvent<HTMLInputElement>) => {
    const keywordValue = event.target.value;
    setSearchInput(keywordValue);
    // onHandleSearchKeyword(keywordValue);
  };

  const onHandleClearKeyword = () => {
    setSearchInput('');
    // onHandleSearchKeyword('');
  };

  const onKeyPress = (e: CustomKeyboardEvent) => {
    if (e.key === 'Enter') {
      onEnterPress?.(e);
    }
  };

  useEffect(() => {
    onHandleSearchKeyword(searchInput);
  }, [onHandleSearchKeyword, searchInput]);

  //use for external event to clear search inputs
  useEffect(() => {
    if (isClearEvent) {
      setSearchInput('');
    }
  }, [isClearEvent]);

  useEffect(() => {
    onHandleSearchKeyword(searchInput);
  }, [onHandleSearchKeyword, searchInput]);

  return (
    <TextField
      value={searchInput}
      label={searchLabel}
      autoComplete="on"
      fullWidth
      name="Search"
      onChange={onChangeKeyword}
      variant="outlined"
      disabled={isDisable}
      onKeyPress={onKeyPress}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <IconButton onClick={onHandleClearKeyword}>
            {searchInput && <CloseIcon />}
          </IconButton>
        )
      }}
    />
  );
};

export const SearchKeyword = memo(component);
